import React from 'react';
import cl from './RefundPolicy.module.css';



const RefundPolicy = (props) => {
    return (
        <section className={cl.app_policy}>
         <h1>Politica di rimborso</h1>
           <h2>Cancellazione</h2>
           <p>Accettiamo l'annullamento dell'ordine prima che il prodotto venga spedito o prodotto. Se l'ordine viene annullato riceverai il rimborso completo.
                 Non possiamo annullare l'ordine se il prodotto è già stato spedito.</p>

           <h2>Resi (se applicabili)</h2>
           <p>Accettiamo la restituzione dei prodotti. I clienti hanno il diritto di richiedere un reso entro 14 giorni dal ricevimento del prodotto.<br/>
                 Per avere diritto a un reso, il tuo articolo deve essere inutilizzato e nelle stesse condizioni in cui lo hai ricevuto. Deve anche
                 essere nella confezione originale. Per completare il reso, abbiamo bisogno di una ricevuta o di una prova d'acquisto. Per favore non inviare
                 il tuo acquisto al produttore o alla nostra stazione di transito.</p>
         </section>
    );
}

export default RefundPolicy;